<app-side-menu>
  <div class="stock-movements-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="stockFilter" class="form-label">Filtrar por Estoque:</label>
          <select 
            id="stockFilter" 
            class="form-select" 
            [(ngModel)]="filters.stockId"
            (change)="applyFilters()">
            <option value="">Todos os estoques</option>
            <option *ngFor="let stock of stocks" [value]="stock.id">
              {{ stock.name }} ({{ stock.code }})
            </option>
          </select>
        </div>

        <div class="filter-group" *ngIf="!isServiceOrderRequestMode">
          <label for="movementTypeFilter" class="form-label">Filtrar por Tipo:</label>
          <select 
            id="movementTypeFilter" 
            class="form-select" 
            [(ngModel)]="filters.movementType"
            (change)="applyFilters()">
            <option value="">Todos os tipos</option>
            <option *ngFor="let type of movementTypes" [value]="type.value">
              {{ type.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option value="">Todos os status</option>
            <option *ngFor="let o of statusFilterOptions" [value]="o.value">
              {{ o.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="startDateFilter" class="form-label">Filtrar por Data Inicial:</label>
          <input 
            id="startDateFilter" 
            type="date" 
            class="form-control" 
            [(ngModel)]="filters.startDate"
            (change)="applyFilters()">
        </div>

        <div class="filter-group">
          <label for="endDateFilter" class="form-label">Filtrar por Data Final:</label>
          <input 
            id="endDateFilter" 
            type="date" 
            class="form-control" 
            [(ngModel)]="filters.endDate"
            (change)="applyFilters()">
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Movimentações -->
    <div *ngIf="!error && (isLoading || filteredData.length > 0)">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="filteredData"
        [loading]="isLoading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [totalItemsFromBackend]="totalItems"
        [itemsPerPage]="pageSize"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (actionClick)="onActionClick($event)">
        <div table-header-action class="movement-quick-actions" *ngIf="!isServiceOrderRequestMode">
          <app-button
            *appHasPermission="['StockMovements.ManualEntry', 'StockMovements.Create']"
            text="Nova Entrada"
            [color]="'var(--primary-light)'"
            [height]="'42px'"
            className="new-movement-btn"
            (buttonClick)="createNewEntryMovement()">
          </app-button>
          <app-button
            *appHasPermission="['StockMovements.ManualExit', 'StockMovements.Create']"
            text="Nova Saída"
            [color]="'var(--primary-dark)'"
            [height]="'42px'"
            className="new-movement-btn"
            (buttonClick)="createNewExitMovement()">
          </app-button>
        </div>
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!isLoading && !error && filteredData.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-exchange-alt"></i>
        <p>{{ isServiceOrderRequestMode ? 'Nenhuma solicitação de OS encontrada' : 'Nenhuma movimentação encontrada' }}</p>
      </div>
      <div class="movement-quick-actions mt-3" *ngIf="!isServiceOrderRequestMode">
        <app-button
          *appHasPermission="['StockMovements.ManualEntry', 'StockMovements.Create']"
          text="Nova Entrada"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-movement-btn"
          (buttonClick)="createNewEntryMovement()">
        </app-button>
        <app-button
          *appHasPermission="['StockMovements.ManualExit', 'StockMovements.Create']"
          text="Nova Saída"
          [color]="'var(--primary-dark)'"
          [height]="'42px'"
          className="new-movement-btn"
          (buttonClick)="createNewExitMovement()">
        </app-button>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <app-modal
      [isOpen]="showLinkItemModal"
      [title]="'Vincular item de estoque'"
      [size]="'md'"
      [closable]="!linkItemSubmitting"
      (close)="closeLinkItemModal()">
      <div *ngIf="showLinkItemModal">
        <p class="text-muted small mb-3">
          Entrada pendente <strong>#{{ linkItemModalPendingEntryId }}</strong>.
          {{ linkItemModalContext }}
        </p>
        <p class="small mb-2">
          Busque o item cadastrado em <strong>Itens</strong> e confirme o vínculo. O status deve avançar de
          <em>solicitado</em> para <em>em trânsito</em>.
        </p>
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="linkItemSearchTerm"
            placeholder="Nome ou código do item..."
            [disabled]="linkItemSubmitting"
            (keyup.enter)="searchLinkItems()" />
          <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="linkItemSubmitting || linkItemSearchLoading"
            (click)="searchLinkItems()">
            <i class="fas fa-search" *ngIf="!linkItemSearchLoading"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="linkItemSearchLoading"></i>
          </button>
        </div>
        <div class="list-group mb-3" *ngIf="linkItemSearchResults.length">
          <button
            type="button"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            *ngFor="let it of linkItemSearchResults"
            [class.active]="linkItemSelectedId === it.id"
            [disabled]="linkItemSubmitting"
            (click)="selectLinkSearchItem(it)">
            <span><strong>{{ it.code }}</strong> — {{ it.name }}</span>
            <i class="fas fa-check text-success" *ngIf="linkItemSelectedId === it.id"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-link p-0 mb-3" *ngIf="linkItemSelectedId" (click)="clearLinkItemSelection()" [disabled]="linkItemSubmitting">
          Limpar seleção
        </button>
      </div>
      <div slot="footer" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" [disabled]="linkItemSubmitting" (click)="closeLinkItemModal()">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!linkItemSelectedId || linkItemSubmitting" (click)="submitLinkPendingItem()">
          <i class="fas fa-spinner fa-spin me-1" *ngIf="linkItemSubmitting"></i>
          Vincular
        </button>
      </div>
    </app-modal>

  </div>
</app-side-menu>
